import type { Router } from 'vue-router'

let router: Router | null = null

export const setRouter = (param: Router) => {
    router = param
}

export const getRouter = (): Router => {
    if (!router) {
        throw new Error('Router not initialized. Call setRouter first.')
    }
    return router
}